import { defaultColors } from '../../Services/contexts/ServicesChartsDataContext';
import { currency } from '../../Util/currency';

export const useSimpleBars = ({
    values,
    subtitles,
    horizontal = false,
    series = null,
    isMoney = false,
    showDataLabels = true,
    stacked = false,
    customColors = null
}) => {
    const chartConfig = {
        series: series ?? [
            {
                name: 'Total',
                data: values || []
            }
        ],
        options: {
            chart: {
                type: 'bar',
                stacked: stacked,
                height: 350,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    horizontal,
                    dataLabels: {
                        position: stacked ? 'center' : 'top' 
                    }
                }
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            dataLabels: {
                enabled: showDataLabels,
                formatter: function (val) {
                    if (val === 0 || val?.toString().length > 5) {
                        return '';
                    }
                    return `${val?.toLocaleString('pt-BR')}`;
                },
                style: {
                    colors: stacked ? ['#fff'] : ['#333'] 
                },
                offsetX: horizontal ? 20 : 0,
                offsetY: stacked ? 0 : (horizontal ? 0 : -20)
            },
            xaxis: {
                categories: subtitles || [],
                labels: {
                    formatter: (val) =>
                        horizontal
                            ? isMoney
                                ? currency.formatToBrCurrency(val)
                                : `${val?.toLocaleString('pt-BR')}`
                            : `${val}`
                }
            },
            yaxis: {
                labels: {
                    formatter: (val) =>
                        horizontal
                            ? `${val}`
                            : isMoney
                            ? currency.formatToBrCurrency(val)
                            : `${val?.toLocaleString('pt-BR')}`
                }
            },
            fill: {
                opacity: 1,
                colors: customColors || defaultColors
            },
            tooltip: {
                y: {
                    formatter: (val) =>
                        isMoney
                            ? currency.formatToBrCurrency(val)
                            : `${val?.toLocaleString('pt-BR')}`
                }
            },
            colors: customColors || defaultColors,
            grid: {
                show: false
            }
        }
    };

    return {
        chartConfig
    };
};